<template>
  <button class="hamburger" @click="$emit('click')">
    <transition name="fade">
      <span v-if="count" class="hamburger__count">{{ count }}</span>
    </transition>
    <span class="hamburger__bars">
      <span class="hamburger__bar"/>
      <span class="hamburger__bar"/>
      <span class="hamburger__bar"/>
    </span>
  </button>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
  .hamburger {
    @include reset-button;
    @include hide-up(md);

    position: fixed;
    top: 38px;
    right: $container-margin;
    z-index: z(details) + 1;

    cursor: pointer;

    &__bars {
      position: relative;
      display: block;
      padding-right: 10px;
    }

    &__bar {
      width: 24px;
      height: 4px;
      display: block;
      margin: 3px 0;

      background-color: $base-opposite-color;
    }

    &__count {
      @include font($akrobat-font, 900);
      font-size: 14px;

      position: absolute;
      right: 0;
      top: -10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Hamburger.vue